import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpCommonService} from '../../../../../../shared/services/http-common.service';
import {Observable} from 'rxjs';
import {GenericHttpResponse} from '../../../../../../shared/services/interfaces/generic-http-response.interface';
import {Objetivos, ObjetivosPayload, ObjetivosResponse, TipoTrabajoObjetivo, TrabajosObjetivoResponse} from './objetivos.interface';

@Injectable({
  providedIn: 'root'
})
export class ObjetivosService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  index(cli_cliente_id: number): Observable<GenericHttpResponse<Objetivos[]>> {
    const url = this.httpCommonService.makeUrl('/clie/objetivos', {cli_cliente_id});
    return this.http.get<GenericHttpResponse<Objetivos[]>>(url);
  }

  show(id: number): Observable<GenericHttpResponse<Objetivos>> {
    const url = this.httpCommonService.makeUrl(`/clie/objetivos/${id}`);
    return this.http.get<GenericHttpResponse<Objetivos>>(url);
  }

  trabajos(id: number, tipo: TipoTrabajoObjetivo, page = 1, per_page = 15): Observable<GenericHttpResponse<TrabajosObjetivoResponse>> {
    const url = this.httpCommonService.makeUrl(`/clie/objetivos/${id}/trabajos`, {tipo, page, per_page});
    return this.http.get<GenericHttpResponse<TrabajosObjetivoResponse>>(url);
  }

  store(body: ObjetivosPayload): Observable<GenericHttpResponse<ObjetivosResponse>> {
    const url = this.httpCommonService.makeUrl('/clie/objetivos');
    return this.http.post<GenericHttpResponse<ObjetivosResponse>>(url, body);
  }

  update(id: number, body: Partial<ObjetivosPayload>): Observable<GenericHttpResponse<ObjetivosResponse>> {
    const url = this.httpCommonService.makeUrl(`/clie/objetivos/${id}`);
    return this.http.put<GenericHttpResponse<ObjetivosResponse>>(url, body);
  }

  destroy(id: number): Observable<GenericHttpResponse<ObjetivosResponse>> {
    const url = this.httpCommonService.makeUrl(`/clie/objetivos/${id}`);
    return this.http.delete<GenericHttpResponse<ObjetivosResponse>>(url);
  }
}
